import { BorderColor } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CardHeader, Modal, Typography } from "@mui/material"
import { JSX, useCallback } from "react";

interface modalProps {
    open:boolean;
    onClose:()=>void;
    style?:Object;
    title?:string;
    content?:JSX.Element;
    msg?:string;
    btnList?:T_mButton[];
}

type t_btnVarinat ="text" | "contained" | "outlined";
type t_btnColor = "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";

type T_mButton = {
      text: string;
      color?: t_btnColor;
      variant?:t_btnVarinat;
      onPress?: () => void;
}
    
const defaultStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    border: '2px solid',
    BorderColor:'main.primary',
    boxShadow: 24,
    p: 0,
  };

export default function NeonModal(props:modalProps){
    
    const hide = useCallback(() => {
        if (props.onClose) {
          props.onClose();
        }
      }, []);
  
    return(
    <Modal
    open={props.open}
    onClose={hide}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box sx={[defaultStyle,props.style as any]}>
     <Box  sx={{w:'100%',height:45, bgcolor: 'primary.main',justifyItems:'center',justifyContent:'center',alignItems:'center',alignContent:'center'}}>
     <Typography variant="h6" color="#fff" noWrap component="div" sx={{ p:0 ,textAlign:'center'}}>
     {props.title}
    </Typography>
     </Box>
    {props.content}  
    <Typography id="modal-modal-description" sx={{ m: 2 }}>
      {props.msg}  
    </Typography>
    <Box    sx={{
    display: 'flex',
    justifyContent: 'center',
    gap: 1,           // MUI spacing 단위: 2 → 16px
    flexWrap: 'wrap', // 버튼 개수가 많을 때 줄바꿈도 가능
    pb:1
  }}>
         {props.btnList?.map((item,idx)=>{
             return(
               <Button color={item.color} variant={item.variant} key={idx}  onClick={item.onPress}>{item.text}</Button>
             )
           })}
          {props.btnList == null?<Button onClick={hide}>예</Button>:""}
    </Box>
        </Box>
    </Modal>
    )
}